const ACTION_ITEMS = {
  ASSESSMENT_PURCHASE: {
    PURCHASE_HISTORY: {
      SET: 'ASSESSMENT_PURCHASE_PURCHASE_HISTORY_SET',
    },
  },
};

export default ACTION_ITEMS;
